import styled, { css } from 'styled-components';
import { Badge } from 'reactstrap';
import tinycolor from 'tinycolor2';
import { darken } from 'polished';

const resolveColor = (theme, color) =>
  theme.colors[color] ??
  color?.split('.').reduce((obj, key) => obj?.[key], theme.colors);

export const BadgeStyled = styled(Badge)`
  border-radius: 24px;
  padding: 4px 8px;
  font-family: Nunito Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0px;
  align-items: center;
  display: inline-flex;
  height: fit-content;
  width: fit-content;
  color: white;
  background: ${({ theme, color }) => resolveColor(theme, color)};
  gap: 4px;

  ${({ color, theme }) => {
    const finalColor = resolveColor(theme, color);
    return (
      !!finalColor &&
      tinycolor(finalColor).isLight() &&
      css`
        color: ${darken(0.55, finalColor)};
        background: ${finalColor};

        svg {
          color: ${darken(0.55, finalColor)};
        }
      `
    );
  }}

  ${({ bordercolor, theme }) =>
    bordercolor &&
    css`
      border: 1px solid ${resolveColor(theme, bordercolor)};
    `};

  ${({ variant }) =>
    variant === 'lg' &&
    css`
      padding: 6px 10px;
      font-size: 16px;
      line-height: 20px;
      gap: 6px;
    `};
`;
